import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDataProvider } from "../hooks/data/DataProvider";

import "./LabLoaderPage.css";

const labInfo = {
    1: {
        name: "NASA Astrobee",
        image: "/static/mdb/img/astrobee.jpg",
    },
    2: {
        name: "MIT SPHERES",
        image: "/static/mdb/img/spheres.jpg",
    },
    3: {
        name: "JAXA Int-Ball2",
        image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLatXIK9n0QsA3zf02dF3CVWi_Kqj0FyONoBiS-WK-cA&s=10",
    },
};

export default function LabLoaderPage() {
    const { labId, projectId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const { getProject } = useDataProvider();

    const project = getProject(projectId);
    const lab = labInfo[labId];

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState("Loading project...");
    const [step, setStep] = useState("");

    const simpleRedirectRef = useRef(null);
    const advancedStartedRef = useRef(null);

    const pollTimerRef = useRef(null);
    const heartbeatTimerRef = useRef(null);
    const mountedRef = useRef(true);

    /* ---------------------------------------------------------
       CLEANUP
    --------------------------------------------------------- */

    useEffect(() => {
        
        mountedRef.current = true;

        return () => {
            mountedRef.current = false;

            if (pollTimerRef.current) {
                console.log("TESTING IDE TYPE. 111111  ");
                clearTimeout(pollTimerRef.current);
                pollTimerRef.current = null;
            }

            if (heartbeatTimerRef.current) {
                console.log("TESTING IDE TYPE. 11111111111  ");
                clearInterval(heartbeatTimerRef.current);
                heartbeatTimerRef.current = null;
            }
        };
    }, []);

    /* ---------------------------------------------------------
       VALIDATE LAB
    --------------------------------------------------------- */

    useEffect(() => {
        console.log("TESTING IDE TYPE. 22222 ");
        if (!labId || !lab) {
            navigate("/labs", { replace: true });
        }
    }, [labId, lab, navigate]);


    /* ---------------------------------------------------------
       WAIT FOR PROJECT
    --------------------------------------------------------- */

    useEffect(() => {
        console.log("TESTING IDE TYPE. 8888  ", project);
        if (!project) return;

        setLoading(true);
        setError("");
    }, [project]);

    /* ---------------------------------------------------------
       SIMPLE IDE
       NO DOCKER
       NO POLLING
    --------------------------------------------------------- */

    useEffect(() => {
        console.log("LAB:", lab);
        console.log("PROJECT ID:", projectId);
        console.log("PROJECT:", project);

        if (!project || !projectId || !lab) {
            console.log("NOT READY:", {
                project: !!project,
                projectId,
                lab: !!lab
            });
            return;
        }

        const ideType = String(project.ide_type || "").toLowerCase();

        console.log("TESTING IDE TYPE. 55555 ", ideType);

        if (ideType !== "simple") return;

        console.log("TESTING IDE TYPE. SIMPLE");

        if (simpleRedirectRef.current === projectId) return;

        simpleRedirectRef.current = projectId;

        setStatus("Opening Simple IDE...");
        setProgress(100);

        const timer = setTimeout(() => {
            console.log(
                "NAVIGATING:",
                `/rect/ide/${labId}/${projectId}`
            );

            if (!mountedRef.current) return;

            navigate(`/rect/ide/${labId}/${projectId}`, {
                replace: true
            });
        }, 1000);

        return () => clearTimeout(timer);

    }, [project, projectId, lab, labId, navigate]);

    /* ---------------------------------------------------------
       ADVANCED IDE - CREATE DOCKER
    --------------------------------------------------------- */

    const openAdvancedProject = useCallback(async () => {
        if (!projectId) return;

        try {
            setLoading(true);
            setError("");
            setProgress(10);
            setStatus("Starting Advanced IDE...");
            setStep("Creating development environment");

            const response = await fetch("/api/docker/create", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    project_id: projectId,
                }),
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                throw new Error(
                    data.message || "Failed to create development environment."
                );
            }

            const containerId = data.container_id;

            if (!containerId) {
                throw new Error("No container ID returned.");
            }

            setProgress(30);
            setStatus("Preparing Advanced IDE...");
            setStep("Starting container");

            pollStatus(containerId);
        } catch (err) {
            console.error("Advanced IDE error:", err);

            if (!mountedRef.current) return;

            setError(err.message || "Failed to start Advanced IDE.");
            setLoading(false);
        }
    }, [projectId]);

    /* ---------------------------------------------------------
       ADVANCED IDE STATUS POLLING
    --------------------------------------------------------- */

    const pollStatus = useCallback(
        (containerId) => {
            if (!containerId) return;

            const check = async () => {
                if (!mountedRef.current) return;

                try {
                    const response = await fetch(
                        `/api/docker/status/${containerId}`,
                        {
                            method: "GET",
                            credentials: "include",
                        }
                    );

                    const data = await response.json();

                    if (!response.ok || !data.success) {
                        throw new Error(
                            data.message || "Unable to check container status."
                        );
                    }

                    if (!mountedRef.current) return;

                    if (data.progress !== undefined) {
                        setProgress(Number(data.progress));
                    }

                    if (data.step) {
                        setStep(data.step);
                    }

                    if (data.status) {
                        setStatus(
                            data.status === "running"
                                ? "Advanced IDE is ready."
                                : `Starting Advanced IDE...`
                        );
                    }
                    console.log("LABLOADER DATA STATUS:    ", data.status);
                    

                    if (data.status === "running") {
                        setProgress(100);

                        setTimeout(() => {
                            if (!mountedRef.current) return;

                            console.log("LABLOADER else:    ", `/rect/ide/${labId}/${projectId}`);
                            navigate(
                                `/rect/ide/${labId}/${projectId}`,
                                {
                                    replace: true,
                                }
                            );

                        }, 300);

                        return;
                    }

                    if (
                        data.status === "failed" ||
                        data.status === "error"
                    ) {
                        throw new Error(
                            data.message || "Failed to start Advanced IDE."
                        );
                    }

                    pollTimerRef.current = setTimeout(check, 1000);
                } catch (err) {
                    console.error("Docker status error:", err);

                    if (!mountedRef.current) return;

                    setError(
                        err.message || "Unable to start Advanced IDE."
                    );
                    setLoading(false);
                }
            };

            check();
        },
        [labId, projectId, navigate]
    );

    /* ---------------------------------------------------------
       START ADVANCED IDE ONLY
    --------------------------------------------------------- */

    useEffect(() => {
        if (!project || !projectId || !lab) return;

        const ideType = String(project.ide_type || "").toLowerCase();

        if (ideType !== "advanced") return;

        if (advancedStartedRef.current === projectId) return;

        advancedStartedRef.current = projectId;

        openAdvancedProject();
    }, [project, projectId, lab, openAdvancedProject]);

    /* ---------------------------------------------------------
       HEARTBEAT
       ONLY IF ADVANCED CONTAINER IS PROVIDED
    --------------------------------------------------------- */

    const startHeartbeat = useCallback((containerId) => {
        if (!containerId) return;

        if (heartbeatTimerRef.current) {
            clearInterval(heartbeatTimerRef.current);
        }

        const heartbeat = async () => {
            try {
                await fetch("/api/docker/heartbeat", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        container_id: containerId,
                    }),
                });
            } catch (err) {
                console.warn("Heartbeat failed:", err);
            }
        };

        heartbeat();

        heartbeatTimerRef.current = setInterval(heartbeat, 30000);
    }, []);

    /* ---------------------------------------------------------
       RETRY
    --------------------------------------------------------- */

    const retry = () => {
        if (!projectId) return;

        setError("");
        setLoading(true);
        setProgress(0);

        advancedStartedRef.current = null;

        openAdvancedProject();
    };

    /* ---------------------------------------------------------
       BACK
    --------------------------------------------------------- */

    const handleBack = () => {
        if (location.state?.from) {
            navigate(location.state.from);
        } else {
            navigate("/dashboard");
        }
    };

    /* ---------------------------------------------------------
       UI
    --------------------------------------------------------- */

    if (!lab) return null;

    const ideType = String(project?.ide_type || "").toLowerCase();

    return (
        <div className="lab-loader-page">
            <div className="loader-card">
                <div className="lab-loader-card">

                    <div className="loader-image-wrapper">
                        <img
                            src={lab.image}
                            alt={lab.name}
                            className="loader-image"
                        />

                        <div className="loader-image-overlay" />
                    </div>

                    <div className="loader-content">

                        <div className="loader-label">
                            {ideType === "advanced"
                                ? "ADVANCED IDE"
                                : "SIMPLE IDE"}
                        </div>

                        <h1 className="loader-project-name">
                            {project?.name || "Loading Project..."}
                        </h1>

                        <p className="loader-description">
                            {project?.description ||
                                `Preparing your ${lab.name} project.`}
                        </p>

                        {error ? (
                            <>
                                <div className="loader-error">
                                    <span className="error-icon">!</span>
                                    <span>{error}</span>
                                </div>

                                {ideType === "advanced" && (
                                    <div className="loader-actions">
                                        <button
                                            className="loader-primary-button"
                                            onClick={retry}
                                        >
                                            Try Again
                                        </button>

                                        <button
                                            className="loader-secondary-button"
                                            onClick={handleBack}
                                        >
                                            Go Back
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="loader-spinner-wrapper">
                                    <div className="loader-spinner" />
                                </div>

                                <div className="progress-container">

                                    <div className="progress-header">
                                        <span>{status}</span>
                                        <span>{progress}%</span>
                                    </div>

                                    <div className="progress-track">
                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${progress}%`,
                                            }}
                                        />
                                    </div>

                                    {step && (
                                        <div className="loader-note">
                                            {step}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}